export default {
  water2nd: 'water 2nd',
  wood3rd: 'wood 3rd',
  metal4th: 'metal 4th',
  earth5th: 'earth 5th',
  fire6th: 'fire 6th',
} as const;
